module.exports = __webpack_public_path__ + "img/step_2.64b6899d.png";